import { settings as raySettings } from '@wework/ray-core';
import debounce from 'lodash/debounce';

const TOOLTIP_ACTIVE_CLASS = 'active-state';
const SELECTORS = {
  TOOLTIP: '.tooltip-box',
  TOOLTIP_CONTENT: '.tooltip-box__content',
  TOOLTIP_BTN: '.tooltip-button'
};

export default class PictureTooltip {
  imageSizes = {
    mobile: 490,
    tablet: 1090,
    desktop: 760
  };

  constructor() {
    this.tooltipList = document.querySelectorAll(SELECTORS.TOOLTIP);
    this.tooltipButtons = Array.from(this.tooltipList).map(tooltip => tooltip.querySelector(SELECTORS.TOOLTIP_BTN));
    this.imageWrapper = document.querySelector('.health-and-safety-measure__image-wrapper');
    this.desktopPoints = [];
    this.devicePoints = [];
    this.corectionPointForDevices = 6;
    // Break width on steps
    this.breakPointStep = 30;

    this.deviceBreakpoints = raySettings.breakpointsInPixels;

    this.initBreakPoints();
    this.onResize();
    window.addEventListener('resize', debounce(this.onResize, 150));
  }

  onResize = () => {
    this.updateTooltipsImage();
    this.updateTooltipBehaviourOnMobileDevice();
  };

  closeAllOpenedTooltipsOnMobile = currentTooltip => {
    this.tooltipList.forEach(tooltip => {
      const isTooltipIsCurrent = currentTooltip && tooltip.dataset.position === currentTooltip.dataset.position;

      if (tooltip.classList.contains(TOOLTIP_ACTIVE_CLASS) && !isTooltipIsCurrent) {
        tooltip.classList.remove(TOOLTIP_ACTIVE_CLASS);
      }
    });
  };

  tooltipMobileListener = event => {
    const tooltip = event.target.parentNode;
    const tooltipContent = tooltip.querySelector(SELECTORS.TOOLTIP_CONTENT);
    const isShown = !!(tooltipContent.offsetWidth && tooltipContent.offsetHeight);

    tooltip.classList.toggle(TOOLTIP_ACTIVE_CLASS, !isShown);
    this.closeAllOpenedTooltipsOnMobile(tooltip);
  };

  updateTooltipBehaviourOnMobileDevice = () => {
    const eventName = 'click';

    if (window.screen.width >= this.deviceBreakpoints.desktop && this.isMobile) {
      this.tooltipButtons.forEach(tooltipButton =>
        tooltipButton.removeEventListener(eventName, this.tooltipMobileListener)
      );
      this.isMobile = false;
    }
    if (window.screen.width < this.deviceBreakpoints.desktop && !this.isMobile) {
      this.tooltipButtons.forEach(tooltipButton =>
        tooltipButton.addEventListener(eventName, this.tooltipMobileListener)
      );
      this.isMobile = true;
    }
  };

  updateTooltipsImage = () => {
    if (this.imageWrapper) {
      const width = this.imageWrapper.offsetWidth;
      if (width > this.imageSizes.desktop) {
        this.desktopPoints.forEach((item, idx) => {
          if (this.desktopPoints[idx] <= width && width <= this.desktopPoints[idx - 1]) {
            this.setTooltipPosition((idx - 1) / 2 - this.corectionPointForDevices);
          }
        });
      } else {
        this.devicePoints.forEach((item, idx) => {
          if (this.devicePoints[idx] <= width && width <= this.devicePoints[idx - 1]) {
            this.setTooltipPosition(idx - 1);
          }
        });
      }
    }
  };

  setTooltipPosition = ratio => {
    this.tooltipList.forEach(tooltip => {
      const [left] = tooltip.dataset.position.split(';');
      tooltip.style.left = `${Number(left) - ratio}%`; // eslint-disable-line no-param-reassign
    });
  };

  initBreakPoints = () => {
    for (let i = this.imageSizes.desktop; i >= this.imageSizes.mobile; i -= this.breakPointStep) {
      this.devicePoints.push(i);
    }

    for (let i = this.imageSizes.tablet; i >= this.imageSizes.desktop; i -= this.breakPointStep) {
      this.desktopPoints.push(i);
    }
  };

  static setUp(options) {
    return new PictureTooltip(options);
  }
}
